import { DataGridSkeleton } from "./DataGrid.skeleton";

export const DocumentDataGridSkeleton: React.FC = () => {
  return <DataGridSkeleton />;
};
